<template>
    <div class="m-rank-view">
        <div class="my-kill">
            我的击败数：<em>{{ $store.state.account.kill || 0 }}</em>
            <div class="u-btn reflash" @click="rank_update(1)"></div>
        </div>
        <div class="evt-info kill-text">{{ $global.activityTime }}每日18:00-23:59，参与天命·荆州争霸地图，获得的累计击败数将计入排名。排行榜将于每日10:00前更新，并于10月7日10:00公布最终排名。</div>

        <div class="m-rank">
            <div class="update-time">本次更新时间：<em>{{ update_time }}</em></div>

            <div class="rank-table">
                
                    <div class="data-table">
                        <vuescroll :ops="ops">
                        <table class="main-table m-rank">
                            <tbody id="J-rank">
                                <tr v-for="(item,index) in list.slice(0,160)" :key="index">
                                    <th class="rank">
                                        <div :class="'rank-' + item.rank">{{ item.rank }}</div>                           
                                    </th>
                                    <th class="area-name">{{ $global.queryArea(item.zid) }}</th>
                                    <th class="player-name">{{ $base64.decode64(item.char_name) }}</th>
                                    <th>{{ item.kill_hero_nums }}</th>                           
                                </tr>
                            </tbody>
                        </table>

                        <table>
                            <tbody class="r-160"></tbody>
                        </table>
                        </vuescroll>
                    </div>
                
            </div>

            <div class="rank-ctrl-view">
                        
                <div class="page" style="display: none;">
                    <div class="u-btn prev"></div>
                    <div class="page-detail">1/10</div>
                    <div class="u-btn next"></div>
                </div>

                <div class="u-btn reward-show" @click="$rank_Modal()"></div>
            </div>
        </div>        
    </div>
</template>

<style scoped>
.m-rank-view{
    width: 725px;
    height: 1834px;
    margin: 0 auto;
    padding: 30px 20px 0;
    background-image: url(~@/assets/images/bg-tab-2.png);
    box-sizing: border-box;
    color: #830101;
}


.my-kill{
    margin-bottom: 24px;
    text-align: center;
}

.my-kill em{
    color: #ff6000;
}

.u-btn.reflash{
    display: inline-block;
    width: 29px;
    height: 26px;
    margin-left: 12px;
    background-image: url(~@/assets/images/btn-reflesh.png);
    vertical-align: text-top;
}

.update-time{
    margin: 5px 0;
    color: #830101;
    text-align: right;
}

.rank-table{
    width: 668px;
    height: 1515px;
    margin: 0 auto;
    padding-top: 75px;
    box-sizing: border-box;
    /* background-image: url(~@/assets/images/bg-rank.png); */
    background-image: url(~@/assets/images/rank-panel.png);
}

.data-table{
    width: 664px;
    height: 1438px;
    margin: 0 auto;
    border-radius: 20px;  
}

.m-rank{
    /* margin-top: 73px; */
    color: #884d19;
}

.m-rank table{
    width: 664px;
    margin: 0 auto;
}

.m-rank .main-table{
    height: 1437px;
}

.m-rank table tr{
    height: 70px;
    background-color: #fff3be;
}

.m-rank table .rank{
    width: 116px;
}

.m-rank table .area-name{
    width: 155px;
}

.m-rank table .player-name{
    width: 240px;
    word-break: break-all;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis; 
}

.rank .rank-1{
    width: 40px;
    height: 39px;
    margin: 0 auto;
    font-size: 0;
    color: transparent;
    background-image: url(~@/assets/images/icon-1st.png);
}

.rank .rank-2{
    width: 40px;
    height: 39px;
    margin: 0 auto;
    font-size: 0;
    color: transparent;
    background-image: url(~@/assets/images/icon-2nd.png);
}

.rank .rank-3{
    width: 25px;
    height: 36px;
    margin: 0 auto;
    font-size: 0;
    color: transparent;
    background-image: url(~@/assets/images/icon-3rd.png);
}

.u-btn.reward-show{
    width: 231px;
    height: 66px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/btn-reward-rank.png);
}
</style>

<script>
export default {
    data (){
        return {
            list : [],
            update_time :'----',
            ops: {
                rail: {
                    opacity: 1,
                    background : '#e9dda9',
                    size: '9px',
                    gutterOfSide : '0px',
                },
                bar: {
                    background: '#884d19',
                    keepShow : true,
                    size: '9px',
                }
            }, // 在这里设置全局默认配置            
        }
    },
    created (){
        this.rank_update();
    },
    methods : {
        rank_update (type){
            this.$axios.get(ajax_url_map.rank)
            .then(
                res => {
                    this.list = res.data;
                    this.update_time = res.data[0].action_date;
                    if(type)this.$toast('刷新成功');
                },
                rej => {
                    if(type)this.$toast('9月2日开始统计数据，敬请期待');
                }
            )
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/rank.vue